import { useSentinelPastViewportEdge } from "./use-sentinel-past-viewport-edge.ts";

export function useFooterRevealed(
    sentinel: HTMLElement | null,
    options: { enabled?: boolean } = {},
): boolean {
    return useSentinelPastViewportEdge(sentinel, "bottom", options);
}
